import { render, staticRenderFns } from "./PromoBox.vue?vue&type=template&id=41c1c1dc&scoped=true"
import script from "./PromoBox.vue?vue&type=script&lang=js"
export * from "./PromoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c1c1dc",
  null
  
)

export default component.exports